import { useState, useEffect } from 'react';
import { apiGetServiceOpenStatus } from 'api/user';
export default function useQueryServiceOpenStatus() {
  const [showKefu, setShowKefu] = useState<boolean>(false);
  useEffect(() => {
    const getServiceOpenStatus = async () => {
      try {
        const res = await apiGetServiceOpenStatus();
        if (res.code === 200) {
          setShowKefu(!!res.data?.switchStatus);
        }
      } catch (err) {}
    };
    getServiceOpenStatus();
  }, []);
  return {
    showKefu,
  };
}
